import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DateSelectorService {

  // tslint:disable: variable-name
  public __trigger = new Subject<any>();
  public __result = new Subject<Date | null>();
  public __mousePosition: number[] = [];

  constructor() {
  }

  public openCalendar(event: MouseEvent) {
    this.__mousePosition = [event.x, event.y];
    this.__trigger.next();
    return this.__result.pipe(take(1));
  }

}
